import './DeparturesContent.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import { useEffect } from "react";

import { useApplyFilters } from "../../../hooks/useApplyFilters";

import { fetchDepartures } from "../../../slices/departuresSlice";

import { openDrawer } from "../../../slices/drawerSlice";

import { Table } from "../../../common-components/Table/Table";
import { List } from "../../../common-components/List/List";
import { Status } from "../../../common-components/Status/Status";
import { Pagination } from "../../../common-components/Pagination/Pagination";

import DeparturesTools from "../DeparturesTools/DeparturesTools";
import Details from "../../../details/Details";

const DeparturesContent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const columns = useSelector((state) => state.departures.columns);
    const data = useSelector((state) => state.departures.data);
    const meta = useSelector((state) => state.departures.meta);

    const { params } = useApplyFilters({componentId: "departures"});

    useEffect(() => {
        dispatch(fetchDepartures({token, params}));
    }, [dispatch, token, params]);


    const requireColumns = [
        ...(columns.start ? columns.start.map(column => ({
            key: column.key,
            header: column.alias || column.name
        })) : [])
    ];

    const clientColumns = [
        ...(columns.middle ? columns.middle.map(column => ({
            key: column.key,
            header: column.alias || column.name
        })) : [])
    ];

    const additionalColumn = [
        ...(columns.end ? columns.end.map(column => ({
            key: column.key,
            header: column.alias || column.name
        })) : [])
    ];

    const handleRowClick = (row) => {
        dispatch(openDrawer({
            content: <Details id={row.id}/>
        }))
    }

    const prepareData = () => {
        return data.map(item => {
            const { id, attributes } = item;

            return { id, ...attributes };
        })
    }

    const preparedData = prepareData();

    const renderCell = (key, value) => {
        if (key === "is_closed") {
            switch (value) {
                case true:
                    return <Status title={"Ликвидировано"} color={"success"}/>
                case false:
                    return <Status title={"В процессе"} color={"danger"}/>
                default:
                    return <Status title={"Отсутствует"}/>
            }
        }

        if (key === "branch_office") {
            return <span>{value || "Не указан"}</span>;
        }
        return value;
    }

    return (
        <div className={"departures-content"}>
            <div className={"departures-content_container"}>
                <div className={"departures-content_tools"}>
                    <DeparturesTools/>
                </div>
                <div className={"departures-content_table"}>
                    <Table requireColumns={requireColumns} clientColumns={clientColumns} data={preparedData} additionalColumns={additionalColumn} renderCell={renderCell} onRowClick={handleRowClick}/>
                </div>
                <div className={"departures-content_list"}>
                    <List requiredColumns={requireColumns} clientColumns={clientColumns} additionalColumns={additionalColumn} data={preparedData} renderCell={renderCell} onClick={(row) => navigate(`/DetailsMobile/${row.id}`)}/>
                </div>
                <div className={"departures-content_pagination"}>
                    <Pagination meta={meta}/>
                </div>
            </div>
        </div>
    )
}

export default DeparturesContent;